import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';

const LoginButton = (): JSX.Element => {
    const { loginWithRedirect } = useAuth0();
    const { t, i18n } = useTranslation();
    const { language } = i18n;

    const handleLogin = () => {
        localStorage.lang = language;
        loginWithRedirect({
            authorizationParams: { ui_locales: language }
        });
    };

    return (
        <button
            id='loginButton'
            className='btn btn-primary'
            onClick={handleLogin}>
            {t('log_in')}
        </button>
    );
};

export default LoginButton;
